module.exports = __webpack_public_path__ + "img/Moldova_GP2.f7dcc4e7.png";